import VerticalEmbedInputModal from './toolbar/VerticalEmbedInputModal.js';
import 'prop-types';
import 'react';
import './toolbar/VerticalEmbedInsertModal.js';
import 'wix-rich-content-plugin-commons';
import 'wix-rich-content-ui-components';
import './constants.js';
import 'ricos-schema';
import './ItemsList-2febaa8a.js';
import './style-inject.es-746bb8ed.js';
import 'classnames';
import './toolbar/itemsList/Item.js';
import 'wix-rich-content-common/libs/imageUtils';
import './convertDuration.js';
import 'lodash';
import './types.js';
import 'wix-rich-content-common';

const Modals = {
  POST_SELECTION_INPUT: "post-selection-input"
};
const ModalsMap = {
  [Modals.POST_SELECTION_INPUT]: VerticalEmbedInputModal
};

export { Modals, ModalsMap };
//# sourceMappingURL=modals.js.map
